import { TIER_PALETTE, type TierKey } from './tier-palette'

export type MedallionState = 'active' | 'past' | 'locked'

export function TierMedallion({
  tier,
  state = 'active',
  className = '',
}: {
  tier: TierKey
  state?: MedallionState
  className?: string
}) {
  const p = TIER_PALETTE[tier]
  const showCrown = (tier === 'diamond' || tier === 'rockstar') && state !== 'locked'
  const showGlow = tier === 'rockstar' && state === 'active'
  const rimId = `rim-${tier}-${state}`
  const shieldId = `shield-${tier}-${state}`
  const glowId = `glow-${tier}-${state}`
  const innerId = `inner-${tier}-${state}`

  const opacity = state === 'locked' ? 0.3 : 1
  const filter = state === 'locked' ? 'grayscale(100%)' : state === 'past' ? 'saturate(0.6)' : 'none'

  return (
    <div className={`relative shrink-0 aspect-square ${className}`} style={{ filter, opacity }}>
      <svg viewBox="0 0 140 140" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        <defs>
          <linearGradient id={rimId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={p.rim[0]} />
            <stop offset="50%" stopColor={p.rim[1]} />
            <stop offset="100%" stopColor={p.rim[2]} />
          </linearGradient>
          <linearGradient id={shieldId} x1="0.5" y1="0" x2="0.5" y2="1">
            <stop offset="0%" stopColor={p.shield[0]} />
            <stop offset="100%" stopColor={p.shield[1]} />
          </linearGradient>
          <radialGradient id={innerId} cx="0.5" cy="0.35" r="0.7">
            <stop offset="0%" stopColor="#2a2f5a" />
            <stop offset="100%" stopColor="#0f1229" />
          </radialGradient>
          <radialGradient id={glowId} cx="0.5" cy="0.5" r="0.5">
            <stop offset="0%" stopColor={p.glow} stopOpacity="0.6" />
            <stop offset="60%" stopColor={p.glow} stopOpacity="0.15" />
            <stop offset="100%" stopColor={p.glow} stopOpacity="0" />
          </radialGradient>
        </defs>

        {showGlow && <circle cx="70" cy="70" r="68" fill={`url(#${glowId})`} />}
        <circle cx="70" cy="70" r="58" fill="none" stroke={`url(#${rimId})`} strokeWidth="7" />
        <circle cx="70" cy="70" r="53" fill="none" stroke={p.rim[1]} strokeWidth="1" opacity="0.4" />
        <circle cx="70" cy="70" r="50" fill={`url(#${innerId})`} />

        <path
          d="M 70 36 L 93 46 L 93 72 Q 93 94 70 106 Q 47 94 47 72 L 47 46 Z"
          fill={`url(#${shieldId})`}
          stroke={p.shieldStroke}
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <polygon
          points="70,58 74,69 86,69 76,76 80,88 70,81 60,88 64,76 54,69 66,69"
          fill={p.star}
          stroke={p.shieldStroke}
          strokeWidth="0.8"
        />
        <path d="M 54 46 L 60 46 L 54 74 Z" fill="#ffffff" opacity="0.08" />

        {showCrown && (
          <g transform="translate(70, 26)">
            <path
              d="M -18 4 L -18 -6 L -11 -2 L -6 -10 L 0 -4 L 6 -10 L 11 -2 L 18 -6 L 18 4 Z"
              fill={p.crown}
              stroke={p.crownStroke}
              strokeWidth="1.2"
              strokeLinejoin="round"
            />
            <rect x="-18" y="3" width="36" height="3" fill={p.crownStroke} opacity="0.7" />
            <circle cx="-11" cy="-3" r="1.6" fill={p.gem} />
            <circle cx="0" cy="-7" r="2" fill={p.gem} />
            <circle cx="11" cy="-3" r="1.6" fill={p.gem} />
          </g>
        )}
      </svg>
    </div>
  )
}
